import React from 'react'
import { observer } from 'mobx-react'
import { Card, CardContent, CardHeader, CardTitle } from 'components/Card'
import { formatToLongDate } from 'utils/date-util'
import JobViewModel from '../JobViewModel'
import styles from './JobTicketsCard.sass'

interface ItemProps {
  label: string
  value: string
}

const Item = ({ label, value }: ItemProps) => {
  return (
    <div className={styles.item}>
      <div className={styles.itemLabel}>{label}</div>
      <div className={styles.itemValue}>{value}</div>
    </div>
  )
}

interface JobTicketsCardProps {
  vm: JobViewModel
}

export default observer(function JobTicketsCard({ vm }: JobTicketsCardProps) {
  const ticket = vm.jobTicketsVM.latestTicket
  if (!ticket) {
    return null
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Open ticket</CardTitle>
      </CardHeader>
      <CardContent scroll>
        {ticket.statusMessage && (
          <Item label="Reason" value={ticket.statusMessage} />
        )}

        <Item
          label="Last updated"
          value={formatToLongDate(ticket.lastUpdated)}
        />
      </CardContent>
    </Card>
  )
})
